import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourDashboardApi from '@/features/dashboard/tours/api/tourDashboardApi.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { TourDashboardOptionsDto } from '@/features/dashboard/tours/types/dashboard/dto/TourDashboardOptionsDto.ts';

const useGetTourDashboardOptions = (tourId: string) =>
  useQuery(getTourDashboardOptionsQueryOptions(tourId));

export const getTourDashboardOptionsQueryOptions = (
  tourId: string,
): UseQueryOptions<TourDashboardOptionsDto> => ({
  queryKey: tourDashboardApiQueryKeys.options(tourId),
  queryFn: () => tourDashboardApi.getOptions(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourDashboardOptions;
